import React, { useState } from "react";
import { FaFileUpload } from "react-icons/fa";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useDispatch } from "react-redux";
import { uploadSponsorPhoto } from "../../redux/actions/action";

const Sponser = ({ onClose, onSubmit }) => {
  const initialSponsor = {
    companyName: "",
    phoneNumber: "",
    website: "",
    photo: null,
    preview: null, // 👈 add this
  };

  const [sponsors, setSponsors] = useState([initialSponsor]);
  const dispatch = useDispatch();

  const handleSponsorChange = (index, field, value) => {
    setSponsors((prev) =>
      prev.map((item, i) => {
        if (i !== index) return item;
        if (field === "photo") {
          return {
            ...item,
            photo: value,
            preview: value ? URL.createObjectURL(value) : null,
          };
        }
        return { ...item, [field]: value };
      })
    );
  };

  const handleAddSponsor = () => {
    setSponsors([...sponsors, { ...initialSponsor }]);
  };

  const handleRemoveSponsor = () => {
    if (sponsors.length > 1) {
      setSponsors(sponsors.slice(0, -1));
    }
  };

  const handleSubmit = async () => {
    const isValid = sponsors.every(
      (s) =>
        s.companyName.trim() !== "" &&
        s.phoneNumber.trim() !== ""
      // Website is optional
    );

    if (!isValid) {
      alert("Please fill all required fields (Company Name, Phone Number)");
      return;
    }

    //onSubmit?.(sponsors);
    //onClose?.();
    try {

      // Upload all sponsor photos
      const updatedItems = await Promise.all(
        sponsors.map(async (item) => {
          if (item.photo) {
            const formData = new FormData();
            formData.append("image", item.photo);
            formData.append("SponsorName", item.companyName); // optional
            const response = await dispatch(uploadSponsorPhoto(formData));
            //console.log("Uploaded photo for:", item.companyName);
            return {
              ...item,
              //uploadedUrl: response || null,
              photo: response || null,
            };
          }
          return item;
        })
      );

      // Now submit the full panel data
      console.log("updated items are " + JSON.stringify(updatedItems), null, 2);
      onSubmit?.(updatedItems);
      onClose?.();

    } catch (err) {
      console.error("Error submitting form or uploading photos:", err);
      alert("Something went wrong. Please try again.");
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      {/* <div className="absolute top-[10px] left-[284px] bg-color p-6 rounded-lg shadow-lg w-[750px] min-h-[200px] max-h-[80vh] overflow-y-auto"> */}
        <div className="bg-color p-6 rounded-lg shadow-lg w-[750px] min-h-[560px] max-h-[80vh] overflow-y-auto">

        <div className="grid grid-cols-2 gap-5">
          {sponsors.map((sponsor, index) => (
            <div key={index} className="relative mb-2">
              <h4 className="font-poppins text-base font-semibold underline mb-2">
                Details of Sponsor {index + 1}:
              </h4>


              {/* Upload Photo */}
              <div className="flex flex-col items-start mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Upload Company Logo
                </label>
                <div className="relative w-[120px] h-[120px] rounded border border-gray-300 overflow-hidden flex items-center justify-center bg-white shadow">
                  {sponsor.preview ? (
                    <img
                      src={sponsor.preview}
                      alt="Preview"
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <FaFileUpload className="text-gray-400 text-3xl" />
                  )}
                  <input
                    type="file"
                    accept="image/*"
                    className="absolute inset-0 opacity-0 cursor-pointer"
                    onChange={(e) =>
                      handleSponsorChange(index, "photo", e.target.files[0])
                    }
                  />
                </div>
              </div>
              {/* Company Name */}
              <div className="mb-2 w-[300px]">
                <label className="block text-sm font-medium text-black mb-1">
                  Company Name*
                </label>
                <input
                  type="text"
                  value={sponsor.companyName}
                  onChange={(e) =>
                    handleSponsorChange(index, "companyName", e.target.value)
                  }
                  placeholder="Enter Company Name"
                  required
                  className="w-full px-3 py-2 border rounded-md"
                />
              </div>

              {/* Phone Number */}
              <div className="mb-2 w-[300px]">
                <label className="block text-sm font-medium text-black mb-1">
                  Phone Number*
                </label>
                <PhoneInput
                  country={"in"}
                  value={sponsor.phoneNumber}
                  onChange={(value) =>
                    handleSponsorChange(index, "phoneNumber", value)
                  }
                  inputClass="!w-full !rounded-md !px-3 !py-2"
                  inputStyle={{ width: "100%" }}
                  enableSearch
                />
              </div>

              {/* Hidden input to enforce validation */}
              <input
                type="tel"
                value={sponsor.phoneNumber}
                required
                style={{ display: "none" }}
                onChange={() => { }}
              />

              {/* Website */}
              <div className="mb-2 w-[300px]">
                <label className="block text-sm font-medium text-black mb-1">
                  Company Website
                </label>
                <input
                  type="text"
                  pattern="^(https?:\/\/)?([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(\/\S*)?$"
                  title="Enter a valid website URL like example.com or https://example.com"
                  placeholder="example.com or https://example.com"
                  value={sponsor.website}
                  onChange={(e) =>
                    handleSponsorChange(index, "website", e.target.value)
                  }
                  className="w-full px-3 py-2 border rounded-md"
                />
              </div>

              {/* Add/Remove Buttons */}
              {index === sponsors.length - 1 && (
                <div className="flex space-x-4 mt-4">
                  <button
                    type="button"
                    onClick={handleAddSponsor}
                    className="bg-white text-black py-2 px-4 font-semibold rounded-md hover:bg-blue-600 transition duration-200"
                  >
                    Add Sponsor
                  </button>
                  {sponsors.length > 1 && (
                    <button
                      type="button"
                      onClick={handleRemoveSponsor}
                      className="bg-white text-black py-2 px-4 font-semibold rounded-md hover:bg-red-600 transition duration-200"
                    >
                      Remove
                    </button>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Submit / Cancel */}
        <div className="flex justify-center space-x-4 mt-8 mb-8">
          <button
            type="button"
            onClick={onClose}
            className="bg-black text-white py-2 px-6 font-semibold rounded-md hover:bg-gray-600 transition duration-200"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleSubmit}
            className="bg-black text-white py-2 px-6 font-semibold rounded-md hover:bg-blue-600 transition duration-200"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default Sponser;
